<div class="soft-ds-drcp-popover">
  <section class="soft-ds-drcp-section">
    <p class="soft-ds-drcp-section-title ds-caption">ZEITRAUM</p>
    <div class="soft-ds-drcp-preset-row">
      @for (p of presets; track p.preset) {
        <soft-ds-button
          size="sm"
          [variant]="isPresetActive(p.preset) ? 'primary' : 'outline'"
          (click)="onPresetClick(p.preset)"
        >
          {{ p.label }}
        </soft-ds-button>
      }
    </div>
  </section>

  <soft-ds-tabs
    class="soft-ds-drcp-granularity"
    layout="fill"
    [tabs]="granularityTabs()"
    [value]="granularityValue()"
    (valueChange)="onGranularityChange($event)"
  />

  @if (!isCustomGranularity() && granularityValue() !== 'fiscalYear') {
    <div class="soft-ds-drcp-year-row">
      @for (y of years(); track y) {
        <soft-ds-button
          size="sm"
          [variant]="isYearActive(y) ? 'primary' : 'outline'"
          (click)="onYearClick(y)"
        >
          {{ y }}
        </soft-ds-button>
      }
    </div>
  }

  @if (granularityValue() === 'fiscalYear') {
    <div class="soft-ds-drcp-year-row">
      @for (fy of fiscalYears(); track fy) {
        <soft-ds-button
          size="sm"
          [variant]="isFiscalYearActive(fy) ? 'primary' : 'outline'"
          (click)="onFiscalYearClick(fy)"
        >
          {{ fiscalYearLabel(fy) }}
        </soft-ds-button>
      }
    </div>
  }

  @if (granularityValue() === 'quarter') {
    <div class="soft-ds-drcp-quarter-row">
      @for (q of quarters; track q) {
        <soft-ds-button
          size="sm"
          [variant]="isQuarterActive(q) ? 'primary' : 'outline'"
          (click)="onQuarterClick(q)"
        >
          Q{{ q }}
        </soft-ds-button>
      }
    </div>
  }

  @if (granularityValue() === 'month') {
    <div class="soft-ds-drcp-month-grid">
      @for (m of months; track m) {
        <soft-ds-button
          size="sm"
          [variant]="isMonthActive(m) ? 'primary' : 'outline'"
          (click)="onMonthClick(m)"
        >
          {{
            [
              'Jan',
              'Feb',
              'Mär',
              'Apr',
              'Mai',
              'Jun',
              'Jul',
              'Aug',
              'Sep',
              'Okt',
              'Nov',
              'Dez',
            ][m]
          }}
        </soft-ds-button>
      }
    </div>
  }

  @if (isCustomGranularity()) {
    <div class="soft-ds-drcp-custom-row">
      <div class="soft-ds-drcp-custom-field">
        <label
          soft-ds-label
          [for]="customFromInputId"
        >
          Von
        </label>
        <soft-ds-date-input
          [showPicker]="false"
          [inputId]="customFromInputId"
          [value]="customFromIso()"
          (valueChange)="onCustomFromChange($event)"
          placeholder="Datum wählen"
        />
      </div>
      <div class="soft-ds-drcp-custom-field">
        <label
          soft-ds-label
          [for]="customToInputId"
        >
          Bis
        </label>
        <soft-ds-date-input
          [showPicker]="false"
          [inputId]="customToInputId"
          [value]="customToIso()"
          (valueChange)="onCustomToChange($event)"
          placeholder="Datum wählen"
        />
      </div>
    </div>
  }

  <div class="soft-ds-drcp-divider"></div>

  <section class="soft-ds-drcp-section">
    <p class="soft-ds-drcp-section-title ds-caption">VERGLEICHZEITRAUM</p>
    <div class="soft-ds-drcp-comparison-row">
      @for (c of comparisons; track c.mode) {
        <soft-ds-button
          size="sm"
          [variant]="isComparisonActive(c.mode) ? 'primary' : 'outline'"
          (click)="onComparisonClick(c.mode)"
        >
          {{ c.label }}
        </soft-ds-button>
      }
    </div>

    @if (isCustomComparison()) {
      <div class="soft-ds-drcp-custom-row">
        <div class="soft-ds-drcp-custom-field">
          <label
            soft-ds-label
            [for]="customCompFromInputId"
          >
            Von
          </label>
          <soft-ds-date-input
            [showPicker]="false"
            [inputId]="customCompFromInputId"
            [value]="customCompFromIso()"
            (valueChange)="onCustomCompFromChange($event)"
            placeholder="Datum wählen"
          />
        </div>
        <div class="soft-ds-drcp-custom-field">
          <label
            soft-ds-label
            [for]="customCompToInputId"
          >
            Bis
          </label>
          <soft-ds-date-input
            [showPicker]="false"
            [inputId]="customCompToInputId"
            [value]="customCompToIso()"
            (valueChange)="onCustomCompToChange($event)"
            placeholder="Datum wählen"
          />
        </div>
      </div>
    }
  </section>

  <div class="soft-ds-drcp-divider"></div>

  <section class="soft-ds-drcp-section">
    <p class="soft-ds-drcp-section-title ds-caption">AUSWAHL</p>
    <div class="soft-ds-drcp-summary">
      <p class="ds-body-2">
        <span class="soft-ds-drcp-summary-label">Zeitraum:</span>
        <span class="soft-ds-drcp-summary-value">{{ summaryRange() }}</span>
      </p>
      <p class="ds-body-2">
        <span class="soft-ds-drcp-summary-label">Vergleich:</span>
        <span class="soft-ds-drcp-summary-value">{{ summaryComparison() }}</span>
      </p>
    </div>
  </section>

  <footer class="soft-ds-drcp-footer">
    @if (isCustomGranularity() || isCustomComparison()) {
      <soft-ds-button variant="ghost" (click)="onReset()">Zurücksetzen</soft-ds-button>
    } @else {
      <soft-ds-button variant="ghost" (click)="onCancel()">Abbrechen</soft-ds-button>
    }
    <soft-ds-button variant="primary" (click)="onApply()">Übernehmen</soft-ds-button>
  </footer>
</div>
